module.exports = __webpack_public_path__ + "img/alitas_2.4c0ca760.jpeg";